import { fetch } from '../../utils';
import Backend from '../../backend';

export const getUploadDocuments = userId => {
  return fetch(Backend.methodUrl('getUploadDocuments') + '/' + userId, {
    method: 'GET'
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
